import { render } from "./BaseComponentPe.vue?vue&type=template&id=c7994608"
import script from "./BaseComponentPe.vue?vue&type=script&lang=js"
export * from "./BaseComponentPe.vue?vue&type=script&lang=js"

import "./BaseComponentPe.vue?vue&type=style&index=0&id=c7994608&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__